module.exports = __webpack_public_path__ + "assets/img/wuzhaung-93937f91.png";